import { createSlice } from "@reduxjs/toolkit";
import { fetchSignIn } from "../thunks/fetch-sign-in-thunk";

const initialState = {
    isSignedIn: false,
    error: null
};

export const signInSlice = createSlice({
    name: "signInSlice",
    initialState,
    reducers: {
        resetSignIn: (state) => {
            state.isSignedIn = false;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchSignIn.fulfilled, (state, action) => {
                state.isSignedIn = action.payload;
            })
            .addCase(fetchSignIn.rejected, (state, action) => {
                state.error = action.error.message;
            });
    }
});

export const selectSignIn = (state) => state.signInSlice.isSignedIn;
export const { resetSignIn } = signInSlice.actions;
